import { defineComponent } from '@vue/composition-api';
import { BootstrapLink } from '../Link';
import { bootstrapBreadcrumbProps } from './Breadcrumb.hooks';
export const BootstrapBreadcrumb = defineComponent({
    name: 'BootstrapBreadcrumb',
    props: bootstrapBreadcrumbProps,
    components: {
        BootstrapLink
    },
    template: `
    <nav class="breadcrumb">
      <ul class="list-unstyled">
        <li v-for="(item, index) in items" :key="index">
          <BootstrapLink v-if="item.path" :link="{ target: { path: item.path } }">
            {{ item.title }}
          </BootstrapLink>
          <template v-else>{{ item.title }}</template>
        </li>
      </ul>
    </nav>
  `
});
